import { render, staticRenderFns } from "./subIndex.vue?vue&type=template&id=609d635a&scoped=true&"
import script from "./subIndex.vue?vue&type=script&lang=js&"
export * from "./subIndex.vue?vue&type=script&lang=js&"
import style0 from "./subIndex.vue?vue&type=style&index=0&id=609d635a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609d635a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('609d635a')) {
      api.createRecord('609d635a', component.options)
    } else {
      api.reload('609d635a', component.options)
    }
    module.hot.accept("./subIndex.vue?vue&type=template&id=609d635a&scoped=true&", function () {
      api.rerender('609d635a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/news/subIndex.vue"
export default component.exports